import {
  DataQualityAccount,
  DataQualityAccountStat,
  DataQualityPolicy,
  DataQualityPolicyStat, DataQualityProgram, DataQualityProgramStats,
  DataQualityRollupEntity,
  DataQualityRollupEntityStat,
  RollupEntityRules
} from '@/types/DataQuality';
import { Service } from './api';

class DataQualityService extends Service {
  async accountList(request: AccountListRequest): Promise<DataQualityAccount[]> {
    return this.get<DataQualityAccount[]>('/v1/data-quality/account', { ...request }).then(this.handleResponse);
  }

  async accountListStats(request: AccountListStatsRequest): Promise<DataQualityAccountStat> {
    return this.get<DataQualityAccountStat>('/v1/data-quality/account/stats', { ...request }).then(this.handleResponse);
  }

  async accountCount(request: AccountCountRequest): Promise<number> {
    return this.get<number>('/v1/data-quality/account/count', { ...request }).then(this.handleResponse);
  }

  async policyList(request: PolicyListRequest): Promise<DataQualityPolicy[]> {
    return this.get<DataQualityPolicy[]>('/v1/data-quality/policy', { ...request }).then(this.handleResponse);
  }

  async policyListStats(request: PolicyListStatsRequest): Promise<DataQualityPolicyStat> {
    return this.get<DataQualityPolicyStat>('/v1/data-quality/policy/stats', { ...request }).then(this.handleResponse);
  }

  async policyCount(request: PolicyCountRequest): Promise<number> {
    return this.get<number>('/v1/data-quality/policy/count', { ...request }).then(this.handleResponse);
  }

  async programList(request: ProgramListRequest): Promise<DataQualityProgram[]> {
    return this.get<DataQualityProgram[]>('/v1/data-quality/program', { ...request }).then(this.handleResponse);
  }

  async programListStats(): Promise<DataQualityProgramStats> {
    return this.get<DataQualityProgramStats>('/v1/data-quality/program/stats').then(this.handleResponse);
  }

  async programCount(rules: number[]): Promise<number> {
    return this.get<number>('/v1/data-quality/program/count', { rules }).then(this.handleResponse);
  }

  async rollupEntityList(request: RollupEntityListRequest): Promise<DataQualityRollupEntity[]> {
    const queryParams = new URLSearchParams();
  
    Object.entries(request.rules).forEach(([ruleType, ruleValues]) => {
      ruleValues.forEach((ruleValue: { toString: () => string; }) => {
        queryParams.append(ruleType, ruleValue.toString());
      });
    });

    queryParams.append('offset', request.offset.toString());
    queryParams.append('limit', request.limit.toString());
  
    const queryString = queryParams.toString();
  
    return this.get<DataQualityRollupEntity[]>(`/v1/data-quality/rollup-entity?${queryString}`).then(this.handleResponse);
  }
  
  async rollupEntityListStats(): Promise<DataQualityRollupEntityStat> {
    return this.get<DataQualityRollupEntityStat>('/v1/data-quality/rollup-entity/stats').then(this.handleResponse);
  }

  async rollupEntityCount(rules: RollupEntityRules): Promise<number> {
    const queryParams = new URLSearchParams();

    Object.entries(rules).forEach(([ruleType, ruleValues]) => {
      ruleValues.forEach((ruleValue: { toString: () => string; }) => {
        queryParams.append(ruleType, ruleValue.toString());
      });
    });

    const queryString = queryParams.toString();

    return this.get<number>(`/v1/data-quality/rollup-entity/count?${queryString}`).then(this.handleResponse);
  }
}

export const dataQualityService = new DataQualityService();

export interface AccountListRequest {
  offset: number;
  limit: number;
  rules: number[];
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
}

export interface AccountListStatsRequest {
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
}

export interface AccountCountRequest {
  rules: number[];
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
}

export interface PolicyListRequest {
  offset: number;
  limit: number;
  rules: number[];
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
  startDate: string | null;
  endDate: string | null;
}

export interface PolicyCountRequest {
  rules: number[];
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
  startDate: string | null;
  endDate: string | null;
}

export interface PolicyListStatsRequest {
  currentOnly: boolean;
  favOnly: boolean;
  serviceRolesOnly: boolean;
  startDate: string | null;
  endDate: string | null;
}

export interface RollupEntityListRequest {
  offset: number;
  limit: number;
  rules: RollupEntityRules;
}

export interface ProgramListRequest {
  offset: number;
  limit: number;
  rules: number[];
}
